import { Contact } from "@repo/server-api";
import { RuleFactoryType } from "@repo/server-api/types";
// import ContactTypeSection from "@repo/legacy/components/shared/sections/ContactTypeSection";
import { PersonIdentification, RuleComponent } from "@repo/shared/components";
import { useTranslation } from "next-i18next";
import React, { forwardRef, useRef, useImperativeHandle, useCallback } from "react";

import Address from "@repo/legacy/components/shared/additionalInformation/Address";
import ContactInfo from "@repo/legacy/components/shared/additionalInformation/ContactInfo";
import DepartmentInfo from "@repo/legacy/components/shared/additionalInformation/DepartmentInformation";
import PaymentCompanyInformation from "@repo/legacy/components/shared/additionalInformation/PaymentCompanyInformation";
import CompanyIdentification from "@repo/legacy/components/shared/sections/CompanyIdentification";
import OtherCompanySection from "@repo/legacy/components/shared/sections/OtherCompanySection";
import OtherPersonSection from "@repo/legacy/components/shared/sections/OtherPersonSection";

const GeneralInfo = forwardRef(
	(
		props: Readonly<{
			contact: Contact | null;
			setContact: (value: Contact | null) => void;
			errors?: Record<string, boolean | object | string>;
			setErrors?: (value: Record<string, boolean | object | string>) => void;
			ruleFactory: RuleFactoryType;
		}>,
		ref: React.Ref<{
			validate: () => Promise<Record<string, boolean | object | string>>;
		}>,
	) => {
		const { t } = useTranslation();

		const addressRef = useRef<{
			validate: () => Promise<Record<string, boolean | object | string>>;
		} | null>(null);
		const companyIdentificationRef = useRef<{
			validate: () => Promise<Record<string, boolean | object | string>>;
		} | null>(null);
		const personIdentificationRef = useRef<{
			validate: () => Promise<Record<string, boolean | object | string>>;
		} | null>(null);
		const contactTypeRef = useRef<{
			validate: () => Promise<Record<string, boolean | object | string>>;
		} | null>(null);
		const contactInfoRef = useRef<{
			validate: () => Promise<Record<string, boolean | object | string>>;
		} | null>(null);
		const otherPersonSectionRef = useRef<{
			validate: () => Promise<Record<string, boolean | object | string>>;
		} | null>(null);
		const paymentCompanyInformationRef = useRef<{
			validate: () => Promise<Record<string, boolean | object | string>>;
		} | null>(null);
		const otherCompanySectionRef = useRef<{
			validate: () => Promise<Record<string, boolean | object | string>>;
		} | null>(null);

		const validateFields = useCallback(async () => {
			const localErrors: Record<string, boolean | object | string> = {};

			localErrors.address = (await addressRef.current?.validate()) ?? {};
			localErrors.contactInfo = (await contactInfoRef.current?.validate()) ?? {};
			if (props.contact?.isACompany) {
				localErrors.companyIdentification =
					(await companyIdentificationRef.current?.validate()) ?? {};
				localErrors.paymentCompanyInformation =
					(await paymentCompanyInformationRef.current?.validate()) ?? {};
			} else {
				localErrors.personIdentification =
					(await personIdentificationRef.current?.validate()) ?? {};
			}

			if (props.ruleFactory.showTypeSection(props.contact)) {
				localErrors.contactType = (await contactTypeRef.current?.validate()) ?? {};
			}

			props.setErrors?.({ ...localErrors });

			return localErrors;
		}, [props]);

		useImperativeHandle(ref, () => ({
			validate: validateFields,
		}));

		return (
			<div>
				<div>
					{/* <RuleComponent
						rule={() => !!props.ruleFactory.showTypeSection(props.contact)()}
					>
						<div className="hrTitle lightGreyFont paddingBottom40">
							<span className="left">
								{t("contacts.contactType").toLocaleUpperCase()}
							</span>
							<hr className="right" />
						</div>
						<ContactTypeSection
							ref={contactTypeRef}
							setErrors={(value: Record<string, boolean | object | string>) =>
								props.setErrors &&
								props.setErrors({
									...props.errors,
									contactType: {
										...((props.errors?.contactType as Record<
											string,
											boolean | object | string
										>) ?? {}),
										...value,
									},
								})
							}
							errors={
								props.errors?.contactType as Record<
									string,
									boolean | object | string
								>
							}
							contact={props.contact}
							setContact={props.setContact}
						/>
					</RuleComponent> */}
					<RuleComponent rule={() => !!props.ruleFactory.isCompany(props.contact)()}>
						<div className="hrTitle lightGreyFont paddingBottom40">
							<span className="left">{t("profile").toLocaleUpperCase()}</span>
							<hr className="right" />
						</div>
						<CompanyIdentification
							ref={companyIdentificationRef}
							setErrors={(value: Record<string, boolean | object | string>) =>
								props.setErrors &&
								props.setErrors({
									...props.errors,
									companyIdentification: {
										...((props.errors?.companyIdentification as Record<
											string,
											boolean | object | string
										>) ?? {}),
										...value,
									},
								})
							}
							errors={
								props.errors?.companyIdentification as Record<string, boolean | object | string>
							}
							contact={props.contact}
							setContact={props.setContact}
						/>
					</RuleComponent>
					<RuleComponent rule={() => !!props.ruleFactory.isPerson(props.contact)()}>
						<div className="hrTitle lightGreyFont paddingBottom40">
							<span className="left">{t("profile").toLocaleUpperCase()}</span>
							<hr className="right" />
						</div>
						<PersonIdentification
							ref={personIdentificationRef}
							setErrors={(value: Record<string, boolean | object | string>) =>
								props.setErrors &&
								props.setErrors({
									...props.errors,
									personIdentification: {
										...((props.errors?.personIdentification as Record<
											string,
											boolean | object | string
										>) ?? {}),
										...value,
									},
								})
							}
							errors={
								props.errors?.personIdentification as Record<string, boolean | object | string>
							}
							contact={props.contact}
							setContact={props.setContact}
						/>

						<div style={{ marginTop: 20 }}>
							{/* <div className="hrTitle lightGreyFont paddingBottom40" style={{ marginTop: 25 }}>
								<span className="left">
									{t("contacts.contactInfo").toLocaleUpperCase()}
								</span>
								<hr className="right" />
							</div> */}
							<ContactInfo
								ref={contactInfoRef}
								contact={props.contact}
								setContact={props.setContact}
								errors={
									props.errors?.contactInfo as Record<string, boolean | object | string> | undefined
								}
								setErrors={(value) =>
									props.setErrors?.({
										...props.errors,
										contactInfo: {
											...((props.errors?.contactInfo as Record<
												string,
												boolean | object | string
											>) ?? {}),
											...value,
										},
									})
								}
							/>
						</div>
					</RuleComponent>
					<RuleComponent
						rule={() =>
							!props.ruleFactory.isEmployee(props.contact)() &&
							!props.ruleFactory.isCompany(props.contact)()
						}>
						<div>
							<div className="hrTitle lightGreyFont paddingBottom40" style={{ marginTop: 25 }}>
								<span className="left">{t("department-information").toLocaleUpperCase()}</span>
								<hr className="right" />
							</div>
							<DepartmentInfo
								isLoaded={!!props.contact}
								contact={props.contact}
								setContact={props.setContact}
							/>
						</div>
					</RuleComponent>
					<div className="clear" />
					<RuleComponent rule={() => !!props.ruleFactory.isPerson(props.contact)()}>
						<div>
							<div className="hrTitle lightGreyFont paddingBottom40" style={{ marginTop: 25 }}>
								<span className="left">{t("address").toLocaleUpperCase()}</span>
								<hr className="right" />
							</div>
							<Address
								isLoaded={!!props.contact}
								ref={addressRef}
								setErrors={(value: Record<string, boolean | object | string>) =>
									props.setErrors &&
									props.setErrors({
										...props.errors,
										address: {
											...(props.errors?.address as Record<string, boolean | object | string>),
											...value,
										},
									})
								}
								errors={props.errors?.address as Record<string, boolean | object | string>}
								contact={props.contact}
								setContact={props.setContact}
							/>
						</div>
					</RuleComponent>
					<RuleComponent rule={() => !!props.ruleFactory.isCompany(props.contact)()}>
						<div>
							<div className="hrTitle lightGreyFont paddingBottom40" style={{ marginTop: 25 }}>
								<span className="left">{t("payment-information").toLocaleUpperCase()}</span>
								<hr className="right" />
							</div>
							<PaymentCompanyInformation
								ref={paymentCompanyInformationRef}
								setErrors={(value: Record<string, boolean | object | string>) =>
									props.setErrors &&
									props.setErrors({
										...props.errors,
										paymentInformation: {
											...((props.errors?.paymentInformation as Record<
												string,
												boolean | object | string
											>) ?? {}),
											...value,
										},
									})
								}
								errors={
									props.errors?.paymentInformation as Record<string, boolean | object | string>
								}
								contact={props.contact}
								setContact={props.setContact}
							/>
						</div>
					</RuleComponent>
					<RuleComponent rule={() => !!props.ruleFactory.isPerson(props.contact)()}>
						<div style={{ marginBottom: 25 }}>
							<div className="hrTitle lightGreyFont paddingBottom40" style={{ marginTop: 25 }}>
								<span className="left">{t("other").toLocaleUpperCase()}</span>
								<hr className="right" />
							</div>
							<OtherPersonSection
								ref={otherPersonSectionRef}
								setErrors={(value: Record<string, boolean | object | string>) =>
									props.setErrors &&
									props.setErrors({
										...props.errors,
										otherSection: {
											...(props.errors?.otherSection as Record<string, boolean | object | string>),
											...value,
										},
									})
								}
								errors={props.errors?.otherSection as Record<string, boolean | object | string>}
								contact={props.contact}
								setContact={props.setContact}
							/>
						</div>
					</RuleComponent>
					<RuleComponent rule={() => !!props.ruleFactory.isCompany(props.contact)()}>
						<div style={{ marginBottom: 25 }}>
							<div className="hrTitle lightGreyFont paddingBottom40" style={{ marginTop: 25 }}>
								<span className="left">{t("other").toLocaleUpperCase()}</span>
								<hr className="right" />
							</div>
							<OtherCompanySection
								ref={otherCompanySectionRef}
								setErrors={(value: Record<string, boolean | object | string>) =>
									props.setErrors &&
									props.setErrors({
										...props.errors,
										otherSection: {
											...(props.errors?.otherSection as Record<string, boolean | object | string>),
											...value,
										},
									})
								}
								errors={props.errors?.otherSection as Record<string, boolean | object | string>}
								contact={props.contact}
								setContact={props.setContact}
							/>
						</div>
					</RuleComponent>
				</div>
			</div>
		);
	},
);

GeneralInfo.displayName = "GeneralInfo";
export default GeneralInfo;
